<template>
  <div class="app-router" v-if="Object.values(detailTransaction).length > 0">
    <v-layout v-resize="onResize" column>
      <v-card id="panel-invoice" elevation="0" outlined flat tile class="mb-5">
        <v-card-subtitle class="pa-0">
          <div class="d-flex justify-end pa-3">
            <v-btn
              small 
              elevation="2"
              dark
              min-width="140" class="btn-primary"
              @click="handlePrint(detailTransaction.trx_midtrans_invoice)"
              :class="(isMobile) ? 'v-btn--block v-size--default' : 'v-size--small'"
            >
              <v-icon color="white darken-1" small class="mr-2">mdi-printer</v-icon>
              <strong class="text-capitalize text-subtitle-2 font-weight-bold">Cetak</strong>
            </v-btn>
          </div>
          <hr />
        </v-card-subtitle>
        <v-card-text class="px-5">
          <div id="section-to-print">
            <!-- <div class="d-flex py-5 my-2 align-center justify-center">
							<v-img width="230" max-width="230" eager src="/assets/icons/logo.png"></v-img>
            </div>-->
            <div class="d-block py-5 black--text">
              <v-row>
                <v-col cols="6" sm="2" class="pb-0 pt-1">
                  <strong>Tanggal</strong>
                </v-col>
                <v-col
                  cols="6"
                  sm="9"
                  class="pl-0 pb-0 pt-1"
                >{{ detailTransaction.trx_status_created_datetime | tanggal }}</v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="2" class="pb-0 pt-1">
                  <strong>Pembayaran</strong>
                </v-col>
                <v-col
                  cols="6"
                  sm="9"
                  class="pl-0 pb-0 pt-1"
                  v-if=" detailTransaction.trx_payment_method=='full_coin_gen'"
                >Coin Gen</v-col>
                <v-col
                  v-else
                  cols="6"
                  sm="9"
                  class="pl-0 pb-0 pt-1"
                >{{ detailTransaction.trx_payment_text.payment_text }}</v-col>
              </v-row>
              <div>
                <v-row
                  v-if="detailTransaction.trx_payment_text && detailTransaction.trx_payment_method == 'bank_transfer'"
                >
                  <v-col cols="6" sm="2" class="pb-0 pt-1">
                    <strong>Rekening Pembayaran</strong>
                  </v-col>
                  <v-col
                    cols="6"
                    sm="9"
                    class="pl-0 pb-0 pt-1"
                  >{{ detailTransaction.trx_payment_data.trx_payment_bank_to_bank_account_number }} a/n {{ detailTransaction.trx_payment_data.trx_payment_bank_to_bank_account_name }}</v-col>
                </v-row>
                <v-row v-else-if="detailTransaction.trx_payment_method == 'midtrans'">
                  <v-col cols="6" sm="2" class="pb-0 pt-1">
                    <strong>Kode Pembayaran</strong>
                  </v-col>
                  <v-col
                    cols="6"
                    sm="9"
                    class="pl-0 pb-0 pt-1"
                  >{{ detailTransaction.trx_midtrans_payment_code }}</v-col>
                </v-row>
              </div>
              <v-row>
                <v-col cols="6" sm="2" class="pb-0 pt-1">
                  <strong>Status</strong>
                </v-col>
                <v-col
                  cols="6"
                  sm="9"
                  class="pl-0 pb-0 pt-1"
                >{{ detailTransaction.trx_midtrans_status | toStatusMidtrans }}</v-col>
              </v-row>
            </div>
            <div class="d-block py-0 black--text">
              <v-card elevation="0" outlined flat shaped tile class="card-darker">
                <v-card-title class="py-2">
                  <div class="text-subtitle-1 font-weight-bold">Ringkasan Pembayaran</div>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="py-5">
                  <div class="text-subtitle-2">Total Belanja</div>
                  <div
                    class="d-flex"
                    :class="(isMobile) ? 'flex-column justify-start' : 'flex-row align-center justify-space-between'"
                  >
                    <span
                      class="font-weight-bold"
                    >- {{ detailTransaction.trx_store_name }} ({{ detailTransaction.trx_midtrans_invoice }})</span>
                    <span
                      :class="(isMobile) ? 'd-block text-subtitle-1 text-left mt-2 font-weight-bold black--text' : 'text-right'"
                    >Rp {{ detailTransaction.trx_bill | toNumber }}</span>
                  </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="py-0">
                  <v-row justify="space-between" class="px-2">
                    <v-col cols="12" sm="6" :class="{'pb-1 text-right': isMobile}">
                      <span class="d-block text-subtitle-2 font-weight-bold">Subtotal Belanja</span>
                    </v-col>
                    <v-col cols="12" sm="6" :class="{'pt-0 text-right': isMobile}">
                      <span
                        class="d-block font-weight-bold"
                        :class="(isMobile) ? 'text-subtitle-1' : 'text-subtitle-2 text-right'"
                      >Rp {{ detailTransaction.trx_bill | toNumber }}</span>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
              <v-row>
                <v-col cols="6" v-if="!isMobile"></v-col>
                <v-col cols="12" sm="6">
                  <v-card elevation="0" outlined flat shaped tile class="card-darker">
                    <v-card-title class="py-1">
                      <v-row justify="space-between">
                        <template v-if="detailTransaction.trx_subtraction_coin_gen>0">
                          <v-col cols="12" sm="6" :class="{'pb-1 text-right': isMobile}">
                            <span
                              class="d-block text-subtitle-1 font-weight-bold darkgreen--text"
                            >Total Belanja</span>
                          </v-col>
                          <v-col cols="12" sm="6" :class="{'pt-0 text-right': isMobile}">
                            <span
                              class="d-block font-weight-bold darkgreen--text"
                              :class="(isMobile) ? 'text-subtitle-1' : 'text-subtitle-2 text-right'"
                            >Rp {{ detailTransaction.trx_bill | toNumber }}</span>
                          </v-col>
                          <v-col cols="12" sm="6" :class="{'pb-1 text-right': isMobile}">
                            <span
                              class="d-block text-subtitle-1 font-weight-bold darkgreen--text"
                            >Coin Gen</span>
                          </v-col>
                          <v-col cols="12" sm="6" :class="{'pt-0 text-right': isMobile}">
                            <span
                              class="d-block font-weight-bold darkgreen--text"
                              :class="(isMobile) ? 'text-subtitle-1' : 'text-subtitle-2 text-right'"
                            >- Rp {{ detailTransaction.trx_subtraction_coin_gen | toNumber }}</span>
                          </v-col>
                        </template>
                        <template>
                          <v-col cols="12" sm="6" :class="{'pb-1 text-right': isMobile}">
                            <span
                              class="d-block text-subtitle-1 font-weight-bold darkgreen--text"
                            >Total Tagihan</span>
                          </v-col>
                          <v-col cols="12" sm="6" :class="{'pt-0 text-right': isMobile}">
                            <span
                              class="d-block font-weight-bold darkgreen--text"
                              :class="(isMobile) ? 'text-subtitle-1' : 'text-subtitle-2 text-right'"
                            >Rp {{ detailTransaction.trx_price_grand_total | toNumber }}</span>
                          </v-col>
                        </template>
                      </v-row>
                    </v-card-title>
                  </v-card>
                </v-col>
              </v-row>
            </div>
            <br />
            <v-divider class="mt-5 mb-2"></v-divider>
            <v-divider class="mb-5"></v-divider>
            <br />
            <div class="d-block py-0 black--text">
              <v-row>
                <v-col cols="12" sm="6">
                  <!-- <v-img width="130" max-width="130" eager src="/assets/icons/logo-pasaroa-green.svg" class="head-logo-2"></v-img> -->
                  <div
                    class="d-flex text-subtitle-1 font-weight-bold mt-3"
                    :class="(isMobile) ? 'flex-column' : 'flex-row'"
                  >
                    <span class="pr-3" :class="{'d-block': isMobile}">Nomor Invoice :</span>
                    <span
                      class="darkgreen--text"
                      :class="{'d-block mb-3': isMobile}"
                    >{{ detailTransaction.trx_midtrans_invoice }}</span>
                  </div>
                  <div class="d-block">Diterbitkan atas nama:</div>
                  <v-row>
                    <v-col cols="4" sm="3" class="pb-0 font-weight-bold">Penjual</v-col>
                    <v-col cols="8" sm="9" class="pb-0">{{ detailTransaction.trx_store_name }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" sm="3" class="py-0 font-weight-bold">Tanggal</v-col>
                    <v-col
                      cols="8"
                      sm="9"
                      class="py-0"
                    >{{ detailTransaction.trx_status_created_datetime | tanggaljam }}</v-col>
                  </v-row>
                </v-col>
                <v-col cols="1" v-if="!isMobile"></v-col>
                <v-col cols="12" sm="5" v-if="detailTransaction.trx_address">
                  <div class="d-flex flex-row text-subtitle-2 font-weight-bold">
                    <span class="pr-3">Pembeli :</span>
                  </div>
                  <div class="d-flex flex-row text-subtitle-2 font-weight-bold mt-1">
                    <span class="pr-3">{{ detailTransaction.trx_address.trx_address_receipt_name }}</span>
                  </div>
                  <div class="text-caption pr-5">
                    <div>{{ detailTransaction.trx_address.trx_address_detail }}</div>
                    <div>{{ detailTransaction.trx_address.trx_address_subdistrict_name }}, {{ detailTransaction.trx_address.trx_address_city_name }}, {{ detailTransaction.trx_address.trx_address_zipcode }}</div>
                    <div>{{ detailTransaction.trx_address.trx_address_province_name }}</div>
                    <div>{{ detailTransaction.trx_address.trx_address_mobilephone }}</div>
                  </div>
                </v-col>
              </v-row>
              <v-divider class="mb-5 my-5"></v-divider>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr class="mb-2" v-if="!isMobile">
                      <th class="text-left" width="40%">
                        <div class="text-subtitle-2 font-weight-bold">Nama Produk</div>
                      </th>
                      <th class="text-center">
                        <div class="text-subtitle-2 font-weight-bold">Jumlah</div>
                      </th>
                      <th class="text-center" width="15%">
                        <div class="text-subtitle-2 font-weight-bold">Berat</div>
                      </th>
                      <th class="text-right" width="20%">
                        <div class="text-subtitle-2 font-weight-bold">Harga Barang</div>
                      </th>
                      <th class="text-right" width="20%">
                        <div class="text-subtitle-2 font-weight-bold">Subtotal</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="!isMobile">
                      <tr
                        v-for="(detail, i) in detailTransaction.trx_detail"
                        :key="detail.trx_detail_id + i"
                      >
                        <td class="text-left">
                          <span
                            class="d-block text-subtitle-2 font-weight-bold"
                          >{{ detail.trx_detail_product_name }}</span>
                        </td>
                        <td class="text-center">{{ detail.trx_detail_quantity }}</td>
                        <td class="text-center">{{ detail.trx_detail_product_weight | toKg }}</td>
                        <td class="text-right">Rp {{ detail.trx_detail_product_price | toNumber }}</td>
                        <td
                          class="text-right"
                        >Rp {{ (detail.trx_detail_product_price) * (detail.trx_detail_quantity) | toNumber }}</td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr
                        v-for="(detail, i) in detailTransaction.trx_detail"
                        :key="detail.trx_detail_id + i"
                      >
                        <td class="text-left">
                          <span
                            class="d-block text-subtitle-2 font-weight-bold mt-2"
                          >{{ detail.trx_detail_product_name }}</span>
                          <span class="d-block text-caption font-weight-normal">
                            Jumlah :
                            <strong class="text-subtitle-2">{{ detail.trx_detail_quantity }}</strong>
                          </span>
                          <span class="d-block text-caption font-weight-normal">
                            Berat :
                            <strong
                              class="text-subtitle-2"
                            >{{ detail.trx_detail_product_weight | toKg }}</strong>
                          </span>
                          <span class="d-block text-caption font-weight-normal">
                            Harga :
                            <strong
                              class="text-subtitle-2"
                            >{{ detail.trx_detail_product_price | toRupiah }}</strong>
                          </span>
                          <v-divider class="my-3"></v-divider>
                          <span
                            class="d-block text-subtitle-2 font-weight-normal text-right"
                          >Subtotal :</span>
                          <span class="d-block text-subtitle-2 font-weight-normal text-right mb-2">
                            <strong>{{ (detail.trx_detail_product_price) * (detail.trx_detail_quantity) | toRupiah }}</strong>
                          </span>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                  <tfoot>
                    <tr>
                      <th :colspan="(isMobile) ? 1 : 5" class="pb-0">
                        <v-divider></v-divider>
                      </th>
                    </tr>
                    <tr>
                      <th :colspan="(isMobile) ? 1 : 5" class="text-right py-0">
                        <div
                          class="d-flex align-center justify-end black--text"
                          :class="(isMobile) ? 'flex-column' : 'flex-row'"
                        >
                          <span
                            class="text-subtitle-1"
                            :class="(isMobile) ? 'text-right d-flex align-self-end' : 'd-block font-weight-bold pr-5 mr-5'"
                          >Subtotal Harga Barang</span>
                          <span
                            class="text-subtitle-1 font-weight-bold text-right"
                            :class="(isMobile) ? 'text-right d-flex align-self-end' : 'd-block pl-5 ml-5'"
                          >Rp {{ detailTransaction.trx_price_total | toNumber }}</span>
                        </div>
                      </th>
                    </tr>
                    <tr>
                      <th :colspan="(isMobile) ? 1 : 5" class="pb-0">
                        <v-divider></v-divider>
                      </th>
                    </tr>
                  </tfoot>
                </template>
              </v-simple-table>
              <v-row>
                <v-col cols="6" v-if="!isMobile"></v-col>
                <v-col cols="12" sm="6">
                  <v-card elevation="0" outlined flat shaped tile>
                    <v-card-title class="py-2">
                      <v-row justify="space-between">
                        <v-col cols="12" sm="6" class="py-2" :class="{'text-right pb-0': isMobile}">
                          <span class="d-block text-caption">Kode Unik</span>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-2">
                          <span
                            class="d-block text-caption font-weight-bold text-right"
                          >{{ detailTransaction.trx_price_unique }}</span>
                        </v-col>
                      </v-row>
                    </v-card-title>
                    <hr />
                    <v-card-title class="py-2">
                      <v-row justify="space-between">
                        <v-col cols="12" sm="6" class="py-2" :class="{'text-right pb-0': isMobile}">
                          <span class="d-block text-caption">Subtotal Ongkos Kirim</span>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-2">
                          <span
                            class="d-block text-caption font-weight-bold text-right"
                          >Rp {{ detailTransaction.trx_price_shipping | toNumber }}</span>
                        </v-col>
                      </v-row>
                    </v-card-title>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6" v-if="!isMobile"></v-col>
                <v-col cols="12" sm="6">
                  <v-card elevation="0" outlined flat shaped tile class="card-darker">
                    <v-card-title class="py-1">
                      <v-row justify="space-between">
                        <template v-if="detailTransaction.trx_subtraction_coin_gen>0">
                          <v-col cols="12" sm="6" :class="{'text-right pb-0': isMobile}">
                            <span
                              class="d-block text-subtitle-1 font-weight-bold darkgreen--text"
                            >Total Belanja</span>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <span
                              class="d-block font-weight-bold darkgreen--text text-right"
                              :class="(isMobile) ? 'text-h5' : 'text-subtitle-1'"
                            >Rp {{ detailTransaction.trx_bill | toNumber }}</span>
                          </v-col>
                          <v-col cols="12" sm="6" :class="{'pb-1 text-right': isMobile}">
                            <span
                              class="d-block text-subtitle-1 font-weight-bold darkgreen--text"
                            >Coin Gen</span>
                          </v-col>
                          <v-col cols="12" sm="6" :class="{'pt-0 text-right': isMobile}">
                            <span
                              class="d-block font-weight-bold darkgreen--text"
                              :class="(isMobile) ? 'text-subtitle-1' : 'text-subtitle-2 text-right'"
                            >- Rp {{ detailTransaction.trx_subtraction_coin_gen | toNumber }}</span>
                          </v-col>
                        </template>
                        <template>
                          <v-col cols="12" sm="6" :class="{'pb-1 text-right': isMobile}">
                            <span
                              class="d-block text-subtitle-1 font-weight-bold darkgreen--text"
                            >Total Tagihan</span>
                          </v-col>
                          <v-col cols="12" sm="6" :class="{'pt-0 text-right': isMobile}">
                            <span
                              class="d-block font-weight-bold darkgreen--text"
                              :class="(isMobile) ? 'text-subtitle-1' : 'text-subtitle-2 text-right'"
                            >Rp {{ detailTransaction.trx_price_grand_total | toNumber }}</span>
                          </v-col>
                        </template>
                      </v-row>
                    </v-card-title>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      isMobile: false
    };
  },
  computed: {
    ...mapState("transaction", ["detailTransaction"]),
    ...mapState("auth", ["isAuth", "userData"])
  },
  methods: {
    ...mapActions("transaction", ["getTransactionDetail"]),

    handlePrint(val) {
      document.title = val;
      window.print();
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    }
  },

  async mounted() {},

  created() {
    this.$store.dispatch("setPageTitle", `Invoice`);
    this.getTransactionDetail({
      invoice: this.$route.params.id
    });
  }
};
</script>

<style lang="scss" scoped>
@media (max-width: 599px) {
}
</style>